// import login from '../../views/login'; // 登陆页
import home from '../../views/home/index'; // 主页
import audit from './audit'; // 系统首页
import identity from './identity'; // 身份管理
import permissions from './permissions'; // 身份管理
import auditMonitoring from './auditMonitoring'; // 审计监控
import common from './common'; // 审计监控
import comprehensiveQuery from './comprehensiveQuery';
import ininCatorReport from './ininCatorReport'; // 报表治标
import systemSet from './systemSet'; // 报表治标
import tableQueryModal from './tableQueryModal'; // 宽表查询模板设置
import setTimeDown from './setTimeDown'; // 定时导出
import labourUnionBusinessReport from './labourUnionBusinessReport';

export default [
    // { path: '/', name: 'login', meta: { title: '登陆' }, component: login },
    {
        path: '/home',
        name: 'home',
        meta: { title: '首页' },
        component: home,
        children: [...audit, ...labourUnionBusinessReport, ...identity, ...permissions, ...auditMonitoring, ...common, ...ininCatorReport, ...systemSet, ...comprehensiveQuery, ...tableQueryModal,
            ...setTimeDown]
    }
];
